import React, { useState, useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { addNewTopic } from "../../../../utils/mainTabs/organize/addNewTopic";
import {
  addTopicActionHandler,
  getRecentlyAddedProgramsTopicActionHandler,
  getTopicByIDActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";
import { useDispatch } from "react-redux";
import { getAllProgramsActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { useSelector } from "react-redux";
import {
  setProgramDataAction,
  setShotClassDataAction,
} from "../../../../store/actions/actionCreators/organizeActionCreator";

const CreateNewTopic = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const routerParams = useParams();
  const pageSize = 8;
  const [shotClassCount, setShotClassCount] = useState(0);
  const [programCount, setProgramCount] = useState(0);
  const [collectionCount, setCollectionCount] = useState(0);
  const [dataForUpdateTopicByID, setDataForUpdateTopicByID] = useState([]);
  const [pathType, setPathType] = useState("");

  const { tiles: newTopicTiles } = addNewTopic;
  const {
    groupTopicTiles,
    setGroupTopicTiles,
    // seriesMgmtTiles,
    createNewTopicPath,
    tenantName,
    topicEditPath,
  } = useOutletContext();

  const [formData, setFormData] = useState({
    details: {
      name: "",
      TagsList: [],
      description: "",
      thumbnailImageFile: [],
    },
    topicContent: {
      // TopicCourseAssociations: [],
      TopicCourseAssociations: [],
    },
  });
  useEffect(() => {
    if (addNewTopic.path) {
      dispatch(
        getAllProgramsActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          setShotClassCount
        )
      );
      dispatch(
        getAllProgramsActionHandler(
          "WithoutVTLT",
          "Published",
          "Program",
          setProgramCount
        )
      );
      // dispatch(
      //   getAllProgramsActionHandler(
      //     "WithoutVTLT",
      //     "Published",
      //     "Collection",
      //     setCollectionCount
      //   )
      // );
    }
  }, [dispatch]);
  const organizeState = useSelector((state) => state.organizeReducer);
  const { shotClassData, programData } = organizeState;
  // useEffect(() => {
  //   dispatch(setProgramDataAction([]));
  //   dispatch(setShotClassDataAction([]));
  // }, [dispatch]);
  // console.log("shotClassData",shotClassData?.length, "programData", programData?.length)
  useEffect(() => {
    dispatch(setShotClassDataAction([]));
    dispatch(setProgramDataAction([]));
  }, []);

  useEffect(() => {
    // console.log(programData, shotClassData);
    if (shotClassData?.length === 0 && programData?.length === 0) {
      // debugger;
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          "none",
          true,
          "none",
          1,
          pageSize,
          false
        )
      );
      dispatch(
        getRecentlyAddedProgramsTopicActionHandler(
          "WithoutVTLT",
          "Published",
          "Program",
          "none",
          true,
          "none",
          1,
          pageSize,
          false
        )
      );
    }
  }, [dispatch, shotClassData?.length, programData?.length]);

  useEffect(() => {
    if (routerParams?.topicID) {
      dispatch(getTopicByIDActionHandler(routerParams?.topicID)).then(
        (response) => {
          if (response) {
            // console.log(response.data);
            setPathType("edit");
            setDataForUpdateTopicByID(response?.data);
            setFormData(() => {
              return {
                details: {
                  name: response?.data?.Name,
                  TagsList:
                    response?.data?.Tags?.length > 0
                      ? response?.data?.Tags?.split(",")?.map((val) => ({
                          TagName: val,
                        }))
                      : "",
                  description: response?.data?.Description,
                  thumbnailImageFile: response?.data?.ImageUrl,
                },
                topicContent: {
                  TopicCourseAssociations:
                    response.data?.TopicCourseAssociations,
                },
              };
            });
          }
        }
      );
    }
  }, [dispatch, routerParams?.topicID]);
  useEffect(() => {
    if (location.pathname == createNewTopicPath) {
      let tilesList = newTopicTiles(
        navigate,
        location,
        routerParams,
        tenantName
      );
      setGroupTopicTiles(tilesList);
      navigate(`${location.pathname}/details`);
    } else if (
      location.pathname.includes(createNewTopicPath) &&
      groupTopicTiles.length === 0
    ) {
      navigate(createNewTopicPath);
    }
  }, [
    location,
    createNewTopicPath,
    routerParams,
    dispatch,
    navigate,
    newTopicTiles,
    newTopicTiles?.length,
    setGroupTopicTiles,
    groupTopicTiles.length,
  ]);
  // console.log("topicEditPath", topicEditPath);

  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <Outlet
        context={{
          formData,
          setFormData,
          shotClassCount,
          programCount,
          collectionCount,
          setShotClassCount,
          setProgramCount,
          setCollectionCount,

          pathType,
          shotClassData,
          programData,
          dataForUpdateTopicByID,
          tenantName,
          topicEditPath,
        }}
      />
    </BoxLayout>
  );
};

export default CreateNewTopic;
